import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from 'src/app/shared/shared.module';
import { LastChildAdminBannerComponent } from './last-child-admin-banner/last-child-admin-banner.component';
import { LastChildAdminTtbComponent } from './last-child-admin-ttb/last-child-admin-ttb.component';
import { LastChildAgentComponent } from './last-child-agent/last-child-agent.component';
import { LastChildEnterpriseCashbackSettingsComponent } from './last-child-enterprise-cashback-settings/last-child-enterprise-cashback-settings.component';
import { LastChildEnterpriseTtbComponent } from './last-child-enterprise-ttb/last-child-enterprise-ttb.component';
import { LastChildEnterpriseComponent } from './last-child-enterprise/last-child-enterprise.component';
import { LastChildGrvComponent } from './last-child-grv/last-child-grv.component';
import { LastChildSmartSafeComponent } from './last-child-smart-safe/last-child-smart-safe.component';
import { LastChildTransactionComponent } from './last-child-transaction/last-child-transaction.component';
import { LastChildVerifyUsersComponent } from './last-child-verify-users/last-child-verify-users.component';
import { LastChildComponent } from './last-child/last-child';
import { TransactionBodyComponent } from './transaction-body/transaction-body.component';
import { UserStatusComponent } from './user-status/user-status.component';
// Import other table components here

@NgModule({
    declarations: [
        LastChildVerifyUsersComponent,
        LastChildTransactionComponent,
        LastChildAgentComponent,
        LastChildComponent,
        LastChildAdminTtbComponent,
        LastChildEnterpriseTtbComponent,
        LastChildGrvComponent,
        LastChildAdminBannerComponent,
        LastChildEnterpriseCashbackSettingsComponent,
        LastChildEnterpriseComponent,
        LastChildSmartSafeComponent,
        TransactionBodyComponent,
        UserStatusComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SharedModule,
    ],
    exports: [
        LastChildVerifyUsersComponent,
        LastChildTransactionComponent,
        LastChildAgentComponent,
        LastChildComponent,
        LastChildAdminTtbComponent,
        LastChildEnterpriseTtbComponent,
        LastChildGrvComponent,
        LastChildAdminBannerComponent,
        LastChildEnterpriseCashbackSettingsComponent,
        LastChildEnterpriseComponent,
        LastChildSmartSafeComponent,
        TransactionBodyComponent,
        UserStatusComponent,
    ]
})
export class TableComponentModule { }
